import { Navigate, Outlet } from 'react-router-dom'

interface GuardedRouteProps {
  isRouteAccessible?: boolean
  /** Default '/' matches HOME_ROUTE. */
  redirectRoute?: string
}

export const GuardedRoute = ({
  isRouteAccessible = false,
  redirectRoute = '/',
}: GuardedRouteProps): JSX.Element =>
  isRouteAccessible ? <Outlet /> : <Navigate to={redirectRoute} replace />
